/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RecaptchaVersion = "V2" | "V3" | "%future added value";
export type SignUpError = "CODEDELIVERYFAILURE" | "ERROR" | "INVALIDPASSWORD" | "RECAPTCHARESPONSENOTVALID" | "VALIDATIONERROR" | "%future added value";
export type LicensingSignUpInput = {
    email: string;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    password: string;
    recaptcha: string;
    recaptchaVersion?: RecaptchaVersion | null | undefined;
};
export type signUpMutationVariables = {
    input: LicensingSignUpInput;
};
export type signUpMutationResponse = {
    readonly licensingSignUp: {
        readonly wasSuccessful: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly errorCode: SignUpError;
            readonly message: string;
        } | null> | null;
    } | null;
};
export type signUpMutation = {
    readonly response: signUpMutationResponse;
    readonly variables: signUpMutationVariables;
};



/*
mutation signUpMutation(
  $input: LicensingSignUpInput!
) {
  licensingSignUp(input: $input) {
    wasSuccessful
    errors {
      errorCode
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "LicensingAccountSignUp",
            "kind": "LinkedField",
            "name": "licensingSignUp",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "wasSuccessful",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DetailedErrorOfLicensingAccountSignUp",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "errorCode",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "signUpMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "signUpMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "a4572d437fa8278437d43875144ebb7e",
            "id": null,
            "metadata": {},
            "name": "signUpMutation",
            "operationKind": "mutation",
            "text": "mutation signUpMutation(\n  $input: LicensingSignUpInput!\n) {\n  licensingSignUp(input: $input) {\n    wasSuccessful\n    errors {\n      errorCode\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '101540d2425f8099d69fb5944c489929';
export default node;
